// src/index.js
import React from "reactn"; // <-- this imports React + your custom useGlobal, setGlobal, etc.
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { usePersistentState } from "reactn"; // from our shim

// Initialize persistence once at app startup
function GlobalInitializer() {
  console.log("🧭 GlobalInitializer rendering...");
  usePersistentState(); // restores & syncs global state with localStorage
  return <App />;
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalInitializer />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
